import { render, staticRenderFns } from "./TrajetMedecinControle.vue?vue&type=template&id=5c39f31e&lang=true"
import script from "./TrajetMedecinControle.vue?vue&type=script&lang=js"
export * from "./TrajetMedecinControle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports